import { IAppState } from '../../redux';
import { TPaymentStatus } from '../../types/reducers/depositAccount';

export function selectRecommendedPackagePaymentStatus(state: IAppState): TPaymentStatus {
  return state.depositAccount.recommendedPackagePaymentStatus;
}
